import { SearchType } from "@domain/enums/SearchType";
import { onMounted, Ref, ref } from "vue";
import { useGenerateSearchTypeUrl } from "./useGenerateSearchTypeUrl";
import { navigateTo } from "nuxt/app";

export const useSearchTypeRedirect = (searchType: SearchType): {loading: Ref<boolean>} => {
	const loading = ref(false);
	const isExternalRedirect = searchType === SearchType.SCHOLARSHIP_SEARCH;

	onMounted( async () => {
		const generatedUrl = await useGenerateSearchTypeUrl(searchType);
		await navigateTo(generatedUrl, {redirectCode: 301, replace: true, external: isExternalRedirect});
		loading.value = true;
	});

	return { loading };
};
